const questionTypes = {
	LIST: {
		REQUEST: 'QUESTION_LIST_REQUEST',
		SUCCESS: 'QUESTION_LIST_SUCCESS',
		FAILURE: 'QUESTION_LIST_FAILURE',
		CLEAR: 'QUESTION_LIST_CLEAR',
	},
	REPLY: {
		REQUEST: 'QUESTION_REPLY_REQUEST',
		SUCCESS: 'QUESTION_REPLY_SUCCESS',
		FAILURE: 'QUESTION_REPLY_FAILURE',
		CLEAR: 'QUESTION_REPLY_CLEAR',
	},
};

export default questionTypes;
